var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloverapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.978 16.282C24.978 12.545 28.0183 9.51469 31.7672 9.51469C35.515 9.51469 38.5535 12.545 38.5535 16.282C38.5535 20.0189 35.512 23.0526 31.7624 23.0526H24.978V16.282ZM24.9771 31.7805C24.9771 35.521 28.0165 38.5492 31.7669 38.5492C35.5129 38.5492 38.5526 35.521 38.5526 31.7805C38.5526 28.0435 35.509 25.0135 31.7606 25.0135H24.9771V31.7805ZM16.234 36.6399C18.9279 36.6399 21.1199 34.4601 21.1199 31.7805V26.9232H16.2403C13.5452 26.9232 11.3523 29.102 11.3523 31.7805C11.3523 34.4601 13.5422 36.6399 16.234 36.6399ZM23.0239 31.7805C23.0239 35.521 19.9842 38.5492 16.234 38.5492C12.488 38.5492 9.44836 35.521 9.44836 31.7805C9.44836 28.0435 12.4917 25.0135 16.2403 25.0135H23.0239V31.7805ZM23.0471 16.2679C23.0471 12.5026 20.0011 9.44922 16.2458 9.44922C12.4913 9.44922 9.44745 12.5026 9.44745 16.2679C9.44745 20.0332 12.4941 23.0899 16.2506 23.0899H23.0471V16.2679Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#228800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#226600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverapp);
export default __webpack_public_path__ + "assets/media/cloverapp.d1a1db78449ce3224a48e38c331c09e8.svg";
export { ForwardRef as ReactComponent };